import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { KpiItem } from '../../models/kpi.model';

@Component({
  selector: 'app-kpi-card-section',
  imports: [CommonModule, FormsModule, TranslatePipe],
  templateUrl: './kpi-card-section.html',
  styleUrl: './kpi-card-section.css',
})
export class KpiCardSection {

  @Input() items: KpiItem[] = [];

  @Input() editable = false;

  addKpi(): void {
    this.items.push({
      title: '',
      value: ''
    });
  }

  removeKpi(index: number): void {
    this.items.splice(index, 1);
  }
}